module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/openai-b7d80c5a8fda96fa7aed9e3dc7998692.svg";